import { render, staticRenderFns } from "./Privacys.vue?vue&type=template&id=bf0294de"
import script from "./Privacys.vue?vue&type=script&setup=true&lang=js"
export * from "./Privacys.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Privacys.vue?vue&type=style&index=0&id=bf0294de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports